"use strict";
const angular = require("angular");

/*@ngInject*/
export function arrowService($rootScope, $location) {
  // AngularJS will instantiate a singleton by calling "new" on this function
  "ngInject";
  return {
    directives: [
      "introduction",
      "project",
      "product",
      "identification",
      "validation",
      "confirmation",
      "board",
    ],
    directive: null,
    activeDir: null,
    projectId: null,
    demandId: null,

    //Url contain the directive name
    getDirective() {
      if ($location.path() === "/permission") {
        var search = $location.search();
        this.directive = "board";
        var id = this.directives.indexOf(search.directive);
        if (search.directive && id !== -1) {
          this.directive = search.directive;
        }
        this.activeDir = this.directive !== "board" ? id : null;
        //console.log(search , this.directive, this.activeDir);
      }
    },

    goto(index, idProject, idDemand, reload, data) {
      //console.log('====>index :', index, this.activeDir);
      //console.log(index, idProject, idDemand);
      if (
        this.activeDir !== null &&
        (this.activeDir !== index || reload) &&
        this.directives[index] !== null &&
        this.directives[index] !== "board"
      ) {
        var s = $location.search();
        let _projectId = s.project ? s.project : idProject || this.projectId;
        let _demandId = s.demand ? s.demand : idDemand || this.demandId;
        this.activeDir = index;
        let params = {
          directive: this.directives[index],
          project: _projectId,
          demand: _demandId,
        };
        if (data && data.date) {
          params.date = data.date;
        }
        //console.log(params);
        $location.path("/permission").search(params);
      }
      //console.log('====>modif index :', this.activeDir);
    },
  };
}

export default angular.module("dalApp.arrow", []).service("arrow", arrowService)
  .name;



// WEBPACK FOOTER //
// ./client/app/permission/permission.service.js